import Vue, { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import { Subtitle1 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import { track } from '@src/util/functions'
import PrintQrCode from '@src/routes/member-platform/components/account/qr-code'
import MemberChangePassword from '@src/routes/member-platform/components/account/change-password'
import { DeleteMemberAction } from '@src/routes/member-platform/components/account/member-actions'
import DownloadLegalDocuments from '@src/components/download-legal/download-legal'
import MemberSettings from '@src/routes/members/components/account/settings'
import MemberPersonalInformation from '@src/routes/member-platform/components/account/personal-information'

import '../../../members/account.sass'

@Component
export default class MemberPersonalAccount extends Vue {

  constructor () {
    super()
    track('/members/account')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.ACCOUNT.ACCOUNT_SETTINGS')}`
  }

  render (h: CreateElement) {
    return <div class='member-account-wrapper  scroll-content'>
      <MemberPersonalInformation />

      <PrintQrCode />

      <MemberSettings readonly={false}/>

      <MemberChangePassword />

      <DeleteMemberAction />

      <Subtitle1>{this.$t('PAGE.MEMBERS.LEGAL.DOWNLOADS')}</Subtitle1>

      <Spacer />
      <DownloadLegalDocuments />
    </div>
  }
}
